<template>
  <div class="add-c-type-select">
    <!-- 选项类型 -->
    <div class="add-c-type-select-type">
       <div class="c-panel-tabView-title">选项类型</div>
       <div class="add-c-type-select-type-radio">
          <el-radio v-model="form.isChoice" label="0" @change="handleRadioChange" :disabled="isEdit">单选</el-radio>
          <el-radio v-model="form.isChoice" label="1" @change="handleRadioChange" :disabled="isEdit">
            <span class="add-c-type-select-type-radio-tip_wrapper">
              <span>多选</span>
              <public-tips content="可以选择多个选项"></public-tips>
            </span>
          </el-radio>
      </div>
     </div>
     <!-- 选项列表 -->
     <div class="add-c-type-select-list">
        <div class="c-panel-tabView-title">选项列表</div>
        <!-- 颜色区分 -->
        <div class="add-c-type-select-list-colorCheck">
          <el-checkbox v-model="isColorChecks" @change = "handleChnageBox">以颜色区分</el-checkbox>
        </div>

        <!-- 列表展示区域 -->
        <div class="add-c-type-select-list-content">
          <select-option
            ref="selectOptions"
            @getList="getSelectList"
            @sort = "handleSort"
            :isChoice="form.isChoice"
            @refresh = "refreshTable"
            :colorFull="isColorChecks"
          >
          </select-option>
        </div>
        <!-- 添加按钮区域 -->
        <div class="add-c-type-select-list-btn">
          <el-button size="mini" @click='lotAdd'>批量添加</el-button>
          <span class="add-c-type-select-list-btn-tips" v-if="nowCustomType==6">最多添加五项</span>
          <transition name = "fade">
          	<el-card v-show='handleBatchAddInputShow' class='batchAddInput'>
          		<el-input
                v-model="handleBatchAddInputVal"
                type='textarea'
          		  placeholder="请将选项用 “换行” 隔开"
                :autosize="{minRows:6}"
              >
          		</el-input>
              <div class="batchAddInput-btnGroup">
                <accBtn
                  text="取消"
                  @click='handleBatchAddInputShow=false'
                  type="2"
                  width="56px"
                  size="mini">
                </accBtn>
                <accBtn
                  text="添加"
                  :loading="addLoading"
                  @click='handleBatchAdd'
                  width="80px"
                  size="mini"
                >
                  添加
                </accBtn>
              </div>
          	</el-card>
          </transition>
        </div>
     </div>
  </div>
</template>

<script>
  import publicTips from "@/components/publicTips/toolTip.vue"
  import selectOption from "./add-type-select-option.vue"
    export default {
      components:{
        publicTips,
        selectOption
      },
      props:{
        nowCustomType:[String,Number],
        isEdit:[Boolean]
      },
      data() {
        return {
          addLoading:false,
          customColumnId:"",
          form:{
            isChoice:"0",  // 0 单选 1多选
            optionList:[],  // 选项列表
          },
          isColorChecks:false,
          handleBatchAddInputShow:false,
          handleBatchAddInputVal:"",
        }
      },
      watch:{

      },
      methods:{
        // 删除表格刷新表格
        refreshTable() {
           this.$emit("refresh",true);
        },
        // 批量添加
        lotAdd() {
          this.handleBatchAddInputVal = "";
          this.handleBatchAddInputShow = true;
        },
        // 选项列表模式改变  清空默认项
        handleRadioChange(e) {
          let list = this.$refs.selectOptions.selectList;
          if(list.length) {
            list.forEach(i=>{
              i.isDefault = false;
            })
            this.form.optionList.forEach(i=>{
              i.isDefault = false;
            })
          }
        },
        getSelectList(list,itemList) {
          if(!list.length) return
          this.batchAddItem(itemList);
          this.form.optionList = list;
        },
        // 添加下拉选项&&按钮
        handleBatchAdd() {
          if(!(this.handleBatchAddInputVal.trim())) {
            return this.$message.warning("新增不能为空！")
          }
          let data = this.handleBatchAddInputVal.split(/[(\r\n)\r\n]+/);
          let optionList = this.$refs.selectOptions.selectList;
          let existData = optionList.map(i=> i.optionName);
          data = [...new Set(data)];
           // 如果现有的存在，则不能添加
          for(var i = 0 ; i < existData.length ; i++) {
            for(var x = 0 ; x < data.length ; x++) {
              if(existData[i] == data[x]) {
                data.splice(x,1)
              }
            }
          }
          if(this.nowCustomType == 6&&data.length>5) {  // 按钮只取前五项
            data.splice(5)
          }
          // 组装数据
          let addDataList = [];
          data.forEach((i,index)=>{
            if(i) {
              this.form.optionList.push({  //  ------ 即将删除
                optionName: i,
                color: this.isColorChecks?this.randomColor():"",
                isDefault:false
              })
              addDataList.push({
                optionName: i,
                color: this.isColorChecks?this.randomColor():"",
                isDefault:false
              })
            }

          })
          if(!addDataList.length) {
            return this.$message.warning("检测到当前添加重复！")
          }
          if(this.customColumnId) {
            this.batchAddItem(addDataList);
          }else {
            this.setArr(this.form.optionList,true);
            this.handleBatchAddInputShow = false;
          }
        },
        // 颜色区分变动
        handleChnageBox() {
          if(!this.customColumnId) return;
          this.$nextTick(()=>{
            setTimeout(()=>{
              let list = this.$refs.selectOptions.selectList;
              if(list.length) {
                this.batchAddItem(list);
                this.form.optionList = list;
              }
            },200)
          })
        },
        // 排序保存接口
        handleSort(arr) {
          if(!this.customColumnId) return;
          let arrList = this.$lodash.cloneDeep(arr);
          arrList.forEach(i => {
            i.isDefault = i.isDefault?1:0;
            i.customColumnId = this.customColumnId;
          })
          let params = {
            list:arrList,
          }
          this.$http.post('custom/sortOptin' , params).then(res=>{
       			if(res&&res.data.code == 1) {
               this.$message.success("排序成功！")
               this.$emit("refresh",true);
       			}
       		})
        },
        // 批量添加接口
        batchAddItem(arr) {
          if(!this.customColumnId) return;
          let arrList = this.$lodash.cloneDeep(arr);
          arrList.forEach(i => {
            i.isDefault = i.isDefault?1:0;
            i.customColumnId = this.customColumnId;
          })
          let params = {
            list:arrList,
          }
          this.addLoading = true;
          this.$http.post('custom/saveOptin' , params).then(res=>{
            this.addLoading = false;
       			if(res&&res.data.code == 1) {
               let datas = res.data.data.optionList;
               this.$message.success("操作成功！")
               this.$emit("refresh",true);
               this.setArr(datas,true);
              this.handleBatchAddInputShow = false;
       			}
       		})
        },
        // 给子组件赋值数组
        setArr(arr,mark) {
         // console.log(arr,mark)
          if(!mark) this.form.optionList = arr;
          // 给以颜色区分赋值
          let isHaveColor = arr.some(i=>{ return i.color })
          this.isColorChecks = isHaveColor;
           
          this.$nextTick(()=>{
            this.$refs.selectOptions.selectList = this.$lodash.cloneDeep(arr);
          })
        },
        // 随机颜色函数
        randomColor(){
        	let r,g,b,a;
        	r = Math.floor(Math.random()*256);
        	g = Math.floor(Math.random()*256);
        	b = Math.floor(Math.random()*256);
        	a = 0.8;
        	return 'rgba(' + r +',' + g + ',' + b + ',' + a +")";
        },
      }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/dialogComponents/add-c-type-select.vue